/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from 'zod/v4'

export const getProjectsProjectidPreferencesUnitsPathProjectIdSchema = z.string()

export const getProjectsProjectidPreferencesUnitsStatus200Schema = z.array(z.object({
  id: z.string().describe('Unique identifier').meta({ examples: [1] }),
  type: z.enum(['area', 'density', 'diameter', 'differentialPressure', 'electricalPower', 'energy', 'flow', 'force', 'heatTransfer', 'kinematicViscosity', 'kvCvCoefficient', 'length', 'linearPressureDrop', 'mass', 'roughness', 'specificHeat', 'staticPressure', 'temperature', 'temperatureDifference', 'thermalConductivity', 'thermalPower', 'thickness', 'torque', 'velocity', 'volume', 'waterHardness']).describe('The type of the unit').meta({ examples: ['length'] }),
  value: z.string().describe('The preferred unit of the user for the given type').meta({ examples: ['_U_LENGTH_CM'] }),
}))

export const getProjectsProjectidPreferencesUnitsStatus401Schema = z.string()

export const getProjectsProjectidPreferencesUnitsResponseSchema = getProjectsProjectidPreferencesUnitsStatus200Schema

export const getProjectsProjectidPreferencesUnitsErrorSchema = getProjectsProjectidPreferencesUnitsStatus401Schema
